import { useCallback, useContext, useMemo, useRef } from 'react';

import {
  JumpDirection,
  Context as NavigationContext
} from '@swf/components/StarsWizard/components/Navigation/Navigation';

import useWizardContext from './useWizardContext';

interface WizardJump {
  jumpForward: (target: string) => void;
  jumpBack: (target: string) => void;
}

const useWizardJump = (): WizardJump => {
  const jumpRef = useRef(true);
  const wizardContext = useWizardContext();
  const { goJump } = useContext(NavigationContext);
  const response = useMemo(() => ({} as WizardJump), []);

  response.jumpForward = useCallback(
    (target: string) => {
      wizardContext.data.goJump = {
        target,
        direction: JumpDirection.Next
      };

      if (jumpRef.current) {
        jumpRef.current = false;
        return goJump();
      }
    },
    [goJump, wizardContext.data]
  );

  response.jumpBack = useCallback(
    (target: string) => {
      wizardContext.data.goJump = {
        target,
        direction: JumpDirection.Previous
      };

      if (jumpRef.current) {
        jumpRef.current = false;
        return goJump();
      }
    },
    [goJump, wizardContext.data]
  );

  return response;
};

export default useWizardJump;
